module.exports = __webpack_public_path__ + "static/img/slsPurpose4.4e92455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsPurpose4.png
// module id = nMlD
// module chunks = 2